module.exports = __webpack_public_path__ + "media/dashboard/assets/images/menu-icons/task-list-square-right-a87b31622751403ff98e0318fa21798e.svg";